module.exports = __webpack_public_path__ + "static/media/juan_musso.0910271a.jpg";